import { Flex, Form } from 'antd';
import { Navigate, useNavigate } from 'react-router-dom';

import unionLogo from '@/assets/images/union-logo.png';
import * as AuthComponent from '@/components/Auth';
import BackButton from '@/components/BackButton';
import Logo from '@/components/Logo';
import OutlinedButton from '@/components/OutlinedButton';
import { useAuth } from '@/contexts/AuthContext';
import { useLoading } from '@/contexts/LoadingContext';
import { ButtonHtmlType, Path } from '@/enums';
import { useBreakpoint } from '@/hooks/useMediaQuery';

import * as Style from './Login.style';

interface LoginFormValues {
  email: string;
  password: string;
}

const Login = () => {
  const [form] = Form.useForm<LoginFormValues>();
  const navigate = useNavigate();
  const { withLoading } = useLoading();
  const { isMobileOrTablet } = useBreakpoint();

  const { token, login: loginUser } = useAuth();

  if (token) {
    return <Navigate to={Path.QuestionnaireSelection} replace />;
  }

  const onFinish = async (values: LoginFormValues) => {
    await withLoading(async () => {
      await loginUser(values.email, values.password);
      navigate(Path.QuestionnaireSelection);
    });
  };

  return (
    <Form
      form={form}
      onFinish={onFinish}
      layout="vertical"
      requiredMark={false}
      style={{ width: '100%' }}
    >
      <Style.FormContainer vertical>
        <Logo
          src={unionLogo}
          alt="Union Logo"
          height="80px"
          style={{ marginBottom: '24px' }}
        />

        <Form.Item
          name="email"
          rules={[
            {
              required: true,
              message: '請輸入電子信箱',
            },
            {
              type: 'email',
              message: '請輸入有效的電子信箱',
            },
          ]}
        >
          <AuthComponent.Input
            type="email"
            autoComplete="email"
            placeholder="請輸入電子信箱"
            width="100%"
            height="3.5rem"
          />
        </Form.Item>

        <Form.Item
          name="password"
          rules={[
            {
              required: true,
              message: '請輸入密碼',
            },
          ]}
        >
          <AuthComponent.InputPassword
            visibilityToggle={false}
            placeholder="請輸入密碼"
            width="100%"
            height="3.5rem"
          />
        </Form.Item>

        <Flex justify="center">
          <Style.CustomLink to={Path.ForgotPassword}>
            忘記密碼？
          </Style.CustomLink>
        </Flex>

        <Style.ButtonGroup>
          <OutlinedButton
            htmlType={ButtonHtmlType.Submit}
            height="4rem"
            width="8rem"
          >
            登入
          </OutlinedButton>

          <OutlinedButton
            height="4rem"
            width="8rem"
            onClick={() => navigate(Path.Register)}
          >
            註冊
          </OutlinedButton>
        </Style.ButtonGroup>

        {isMobileOrTablet && <BackButton to={Path.Root} />}
      </Style.FormContainer>
    </Form>
  );
};

export default Login;
